<template>
    <b-modal
        ref="contactModal"
        hide-header
        hide-footer
        centered
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        size="lg"
        @shown="addEventListeners"
        @hide="removeEventListeners"
    >
      <slot name="icon">
        
      </slot>
        <div class="swal-title" style="color:#000;border-bottom: 1px solid #000;text-align: center;">
            <div class="title-content">
                <h3>{{ companyName }}</h3>
                <p>{{ jobTitle}}</p>
            </div>
        </div>
        <slot name="content">
        </slot>
    </b-modal>
</template>

<script>
import modalEventListener from "../../mixins/modalEventListener";
export default {
    name: 'ContactModal',
    props:["companyName", "jobTitle"],
    mixins: [modalEventListener],
    methods: {
        cancel(){
            this.$emit('hideModal')
        }
    },
    mounted(){
        this.$refs.contactModal.show();
    }
}
</script>
<style scoped>

.title-content p {
    font-weight: normal;
    font-size: 18px;
}

.title-content h3 {
    font-weight: bold;
}
.swal-icon:first-child {
    margin-top: 32px;
}

.swal-icon {
    width: 80px;
    height: 80px;
    border-width: 4px;
    border-style: solid;
    border-radius: 50%;
    padding: 0;
    position: relative;
    box-sizing: content-box;
    margin: 20px auto;
}

.swal-icon--warning {
    border-color: #f8bb86;
    -webkit-animation: pulseWarning .75s infinite alternate;
    animation: pulseWarning .75s infinite alternate;
}

.swal-icon--warning__body, .swal-icon--warning__dot {
    position: absolute;
    left: 50%;
    background-color: #f8bb86;
}

.swal-icon--warning__body {
    width: 5px;
    height: 47px;
    top: 10px;
    border-radius: 2px;
    margin-left: -2px;
}

</style>